"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoverPhotoUrl = exports.generatePolicyUrl = exports.generateTosUrl = exports.generateLayoutWidth = exports.generateParagraphs = void 0;

var _react = _interopRequireDefault(require("react"));

var _Elements = require("../Elements");

var _helpers = require("../../../lib/helpers");

var _constants = require("../constants/constants");

// Note: one newline is a linebreak <br/>, two newlines are a new paragraph <p>
// this isn't a perfect system, but it's the closest we can get.
// Note 2: this is an english/latin/romance-centric system, supporting display of other
// languages is bit beyond scope right now
// Note 3: \n\n, \n\r, \r\n and \r\r are all equivalent due to historical issues
var paragraphRegex = /\n\n|\r\r|\r\n|\n\r/;
var linebreakRegex = /\n|\r/; // eslint-disable-next-line import/prefer-default-export

var generateParagraphs = function generateParagraphs(_ref) {
  var _description$split;

  var description = _ref.description,
      isDesktopSmall = _ref.isDesktopSmall;
  var paragraphs = description === null || description === void 0 ? void 0 : (_description$split = description.split) === null || _description$split === void 0 ? void 0 : _description$split.call(description, paragraphRegex);
  var descriptionElements = paragraphs ? paragraphs.map(function (paragraph, index) {
    var linebreaks = paragraph.split(linebreakRegex);
    var linebreakElements = linebreaks.length > 1 ? linebreaks.map(function (linebreak, jindex) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react["default"].createElement(_react["default"].Fragment, {
          key: "portfolio-text-block-".concat(jindex)
        }, linebreak, /*#__PURE__*/_react["default"].createElement("br", null))
      );
    }) : paragraph;
    return /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph // eslint-disable-next-line react/no-array-index-key
    , {
      key: "portfolio-paragraph-".concat(index),
      large: isDesktopSmall,
      portfolioForeground1: true
    }, linebreakElements);
  }) : /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    large: isDesktopSmall,
    portfolioForeground1: true
  }, description);
  return descriptionElements;
};

exports.generateParagraphs = generateParagraphs;

var generateLayoutWidth = function generateLayoutWidth(columns, columnWidth, gutter) {
  return columns * columnWidth + gutter * (columns - 1);
};

exports.generateLayoutWidth = generateLayoutWidth;

var generateTosUrl = function generateTosUrl(portfolio, publicUrl) {
  var _portfolio$termsOfUse, _portfolio$termsOfUse2, _portfolio$termsOfUse3;

  var url = null;

  switch (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$termsOfUse = portfolio.termsOfUse) === null || _portfolio$termsOfUse === void 0 ? void 0 : _portfolio$termsOfUse.type) {
    case _constants.TOS_PRIVACY_TYPE.HIDDEN:
      break;

    case _constants.TOS_PRIVACY_TYPE.PX_PROVIDED:
      url = "".concat(publicUrl, "/terms");
      break;

    default:
      // type is undefined
      url = (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$termsOfUse2 = portfolio.termsOfUse) === null || _portfolio$termsOfUse2 === void 0 ? void 0 : _portfolio$termsOfUse2.url) && (0, _helpers.createExternalUrl)(portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$termsOfUse3 = portfolio.termsOfUse) === null || _portfolio$termsOfUse3 === void 0 ? void 0 : _portfolio$termsOfUse3.url);
  }

  return url;
};

exports.generateTosUrl = generateTosUrl;

var generatePolicyUrl = function generatePolicyUrl(portfolio, publicUrl) {
  var _portfolio$privacyPol, _portfolio$privacyPol2, _portfolio$privacyPol3;

  var url = null;

  switch (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$privacyPol = portfolio.privacyPolicy) === null || _portfolio$privacyPol === void 0 ? void 0 : _portfolio$privacyPol.type) {
    case _constants.TOS_PRIVACY_TYPE.HIDDEN:
      break;

    case _constants.TOS_PRIVACY_TYPE.PX_PROVIDED:
      url = "".concat(publicUrl, "/policy");
      break;

    default:
      // type is undefined
      url = (portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$privacyPol2 = portfolio.privacyPolicy) === null || _portfolio$privacyPol2 === void 0 ? void 0 : _portfolio$privacyPol2.url) && (0, _helpers.createExternalUrl)(portfolio === null || portfolio === void 0 ? void 0 : (_portfolio$privacyPol3 = portfolio.privacyPolicy) === null || _portfolio$privacyPol3 === void 0 ? void 0 : _portfolio$privacyPol3.url);
  }

  return url;
};

exports.generatePolicyUrl = generatePolicyUrl;

var getCoverPhotoUrl = function getCoverPhotoUrl(coverPhoto) {
  var _coverPhoto$avatar, _coverPhoto$avatar$im, _coverPhoto$images$;

  var url = coverPhoto !== null && coverPhoto !== void 0 && coverPhoto.avatar ? coverPhoto === null || coverPhoto === void 0 ? void 0 : (_coverPhoto$avatar = coverPhoto.avatar) === null || _coverPhoto$avatar === void 0 ? void 0 : (_coverPhoto$avatar$im = _coverPhoto$avatar.images[0]) === null || _coverPhoto$avatar$im === void 0 ? void 0 : _coverPhoto$avatar$im.url : coverPhoto === null || coverPhoto === void 0 ? void 0 : (_coverPhoto$images$ = coverPhoto.images[0]) === null || _coverPhoto$images$ === void 0 ? void 0 : _coverPhoto$images$.url;
  return url;
};

exports.getCoverPhotoUrl = getCoverPhotoUrl;